export default "__VITE_ASSET__CI_VD4tM__"